export default __webpack_public_path__ + "static/media/kinoladder_banner.3f04c04a.png";